import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

export const FullPageError: React.FC = () => {
  // Light theme tokens
    const bg = useColorModeValue(
    "linear(to-br, #E5E7EB, #E5E7EB)",
    "linear(to-br, gray.900, gray.900)"
  );
  const textColor = useColorModeValue("gray.800", "white");


  const headingGradient = useColorModeValue(
    "linear(to-r, #F97316, #FB923C)",
    "linear(to-r, orange.300, orange.500)"
  );

  return (
    <Box
      textAlign="center"
      py={12}
      px={6}
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={bg}
      color={textColor}
      _dark={{
        bgGradient: "linear(to-br, gray.800, gray.900)", 
      }}
    >
      <VStack spacing={6}>
        <Heading
          size="4xl"
          bgGradient={headingGradient}
          backgroundClip="text"
          fontWeight="extrabold"
        >
          :(
        </Heading>

        <Text fontSize="2xl" fontWeight="semibold">
          An unexpected error has occurred.
        </Text>

        <Text
          fontSize="md"
          maxW="md"
          color={textColor}
        >
          Our engineers have been notified and will fix this as soon as possible.
          Please try reloading the page.
        </Text>

        <Button
          size="lg"
          bg="#F97316"
          color="white"
          _hover={{ bg: "#FB923C" }}
          onClick={() => window.location.reload()}
        >
          Reload Page
        </Button>
      </VStack>
    </Box>
  );
};
